export default (/[а-яА-ЯЁё]/);
